export default class FollowUsOption {
    public followUsId: number;
    public name: string;

    constructor(obj: any) {
        if(obj) {
            this.followUsId = obj.followUsId;
            this.name = obj.name;
        }
    }
}